import { useTranslation } from 'react-i18next';
import { ListCard } from 'components/ds';
import styles from './SponsoredPlaces.module.css';

export interface SponsoredPlace {
    id: string;
    name: string;
    /** 카테고리 · 거리 등 */
    meta?: string;
    imageUrl?: string | null;
    /** 한 줄 홍보 문구. 추천의 "근거" 자리에 들어갑니다 */
    pitch?: string;
    onClick?: () => void;
}

/**
 * 스폰서 장소.
 *
 * 추천 구역과 선으로 가릅니다. 추천은 "왜 이 가게인지" 를 말할 수 있어야 하고
 * 광고는 그 말을 할 수 없습니다. 둘을 섞으면 근거 뱃지 전체가 못 믿을 것이 됩니다.
 * 그래서 추천 스택 맨 끝에만 두고, 라벨을 반드시 답니다.
 *
 * 카드 모양은 추천과 같게 둡니다 — 다르게 만들면 광고 효과가 떨어지고,
 * 라벨을 빼면 사용자를 속이는 것이 됩니다.
 *
 * 넘겨줄 데이터가 없으면 아무것도 그리지 않습니다.
 */
export const SponsoredPlaces = ({ places }: { places?: SponsoredPlace[] | null }) => {
    const { t } = useTranslation();
    const list = (places || []).filter(p => p && p.name);
    if (list.length === 0) return null;

    return (
        <div className={styles.wrap}>
            <span className={styles.label}>{t('placeExplore.adSection')}</span>
            <div className={styles.rows}>
                {list.map(p => (
                    <ListCard
                        key={p.id}
                        title={p.name}
                        sub={p.meta}
                        imageUrl={p.imageUrl}
                        evidence={p.pitch}
                        onClick={p.onClick}
                    />
                ))}
            </div>
        </div>
    );
};
